import { Controller } from "@hotwired/stimulus"
import { MetadataEditor } from '../editors/metadataEditor'

export default class extends Controller {
  static targets = ["textarea", "editor"]

  connect() {
    this.editor = new MetadataEditor({
      parent: this.editorTarget,
      initialValue: this.textareaTarget.value,
      onChange: (newValue) => {
        this.textareaTarget.value = newValue;
      }
    });
  }

  disconnect() {
    if (this.editor) {
      this.editor.destroy();
    }
  }
}
